import { createSlice } from '@reduxjs/toolkit';
import { addNewQuotation, changeQuotationStatus, editQuotation, getAllQuotationList, getQuotationById } from './quotationService';

const initialState = {
  allQuotationList: {
    isQuotationListLoading: null,
    isQuotationListSuccess: null,
    quotationListMessage: null,
    pageCount: 0,
    quotationList: [],
  },

  newQuotation: {
    isQuotationCreating: null,
    isQuotationCreated: null,
    quotationCreationMsg: null,
  },

  editedQuotation: {
    isEditingQuotation: null,
    isQuotationEdited: null,
    quotationEditedMsg: null
  },

  quotationDetails: {
    isQuotationLoading: null,
    isQuotationSuccess: null,
    quotation: null
  },

  changeStatus: {
    isStatusLoading: null,
    isStatusSuccess: null,
  },
};

const quotationSlice = createSlice({
  name: 'quotation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllQuotationList.pending, (state) => {
        state.allQuotationList = {
          ...initialState.allQuotationList, // Reset to initial state
          isQuotationListLoading: true,
          quotationListMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllQuotationList.rejected, (state, action) => {
        state.allQuotationList = {
          ...initialState.allQuotationList,
          isQuotationListLoading: false,
          isQuotationListSuccess: false,
          quotationListMessage: action.payload || 'Error occurred while fetching quotationList',
        };
      })

      // FULFILLED
      .addCase(getAllQuotationList.fulfilled, (state, action) => {
        state.allQuotationList = {
          ...initialState.allQuotationList,
          isQuotationListLoading: false,
          isQuotationListSuccess: true,
          pageCount: action.payload.pageCount || 0,
          quotationList: action.payload.data || [],
        };
      });

    //Quotation creating
    builder
      .addCase(addNewQuotation.pending, (state) => {
        state.newQuotation = {
          ...initialState.newQuotation, // Reset to initial state
          isQuotationCreating: true,
          quotationCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewQuotation.rejected, (state, action) => {
        state.newQuotation = {
          ...initialState.newQuotation,
          isQuotationCreating: false,
          isQuotationCreated: false,
          quotationCreationMsg: action.payload || 'Error occurred while creating the quotation.',
        };
      })

      // FULFILLED
      .addCase(addNewQuotation.fulfilled, (state, action) => {
        state.newQuotation = {
          ...initialState.newQuotation,
          isQuotationCreating: false,
          isQuotationCreated: true,
          quotationCreationMsg: action.payload || 'Successfully created the quotation.',
        };
      });

    //Quotation editing
    builder
      .addCase(editQuotation.pending, (state) => {
        state.editedQuotation = {
          ...initialState.editedQuotation, 
          isEditingQuotation: true,
          quotationEditedMsg: 'Loading',
        };
      })

      .addCase(editQuotation.rejected, (state, action) => {
        state.editedQuotation = {
          ...initialState.editedQuotation,
          isEditingQuotation: false,
          isQuotationEdited: false,
          quotationEditedMsg: action.payload || 'Error occurred while editing the quotation.',
        };
      })

      .addCase(editQuotation.fulfilled, (state, action) => {
        state.editedQuotation = {
          ...initialState.editedQuotation,
          isEditingQuotation: false,
          isQuotationEdited: true,
          quotationEditedMsg: action.payload || 'Successfully edited the quotation.',
        };
      });

       //Quotation details
    builder
    .addCase(getQuotationById.pending, (state) => {
      state.quotationDetails = {
        ...initialState.quotationDetails, 
        isQuotationLoading: true,
      };
    })

    .addCase(getQuotationById.rejected, (state, action) => {
      state.quotationDetails = {
        ...initialState.quotationDetails,
        isQuotationLoading: false,
        isQuotationSuccess: false,
      };
    })

    .addCase(getQuotationById.fulfilled, (state, action) => {
      state.quotationDetails = {
        ...initialState.quotationDetails,
        isQuotationLoading: false,
        isQuotationSuccess: true,
        quotation: action.payload,
      };
    });

     //Change Quotation Status
     builder
     .addCase(changeQuotationStatus.pending, (state) => {
      state.changeStatus = {
        ...initialState.changeStatus,
        isStatusLoading: true,
      };
     })

     .addCase(changeQuotationStatus.rejected, (state, action) => {
      state.changeStatus = {
        ...initialState.changeStatus,
        isStatusLoading: false,
        isStatusSuccess: false,
      };
     })

     .addCase(changeQuotationStatus.fulfilled, (state, action) => {
       state.changeStatus = {
         ...initialState.changeStatus,
         isStatusLoading: false,
         isStatusSuccess: true,
       };
     });
  },
});

export default quotationSlice.reducer;
